import { SubmitApplicationComponent } from "../Componentns/SubmitApplicationComponent";

const SubmitApplication = () => {
    return (
        <SubmitApplicationComponent />
    );
}

export default SubmitApplication;